export default "__VITE_ASSET__CVrFzn0F__"